import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { Separator } from "../../theme/typography";

import { AddNews } from "./components/addNews/addNews.component";
import { LatestNews } from "./components/latestNews/latestNews.component";
import { NewsFeed } from "./components/newsFeed/newsFeed.component";
import { EntryDetails } from "./components/entryDetails/entryDetails.component";
import { Config } from "./news.config";
import {
  Content,
  Container,
  Sidebar,
  PageHeader,
  Wrapper,
  Section,
  BackButton,
} from "./news.styled";
import { CheckAuth } from '../../components/checkAuth/checkAuth.component';

const News = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (Config.urls.includes(location.pathname)) {
      navigate(Config.routes.init, { replace: true });
    }
  }, [location.pathname]);

  const StartPage = () => (
    <>
      <AddNews />
      <Separator />
      <NewsFeed />
    </>
  );

  const RenderHeader = () => <PageHeader>{t(Config.label)}</PageHeader>;

  const RenderDetails = () => (
    <>
      <BackButton defaultPath="/news" />
      <EntryDetails />
    </>
  );

  return (
    <Container>
      <Wrapper>
        <Routes>
          <Route path={Config.routes.init} exact element={<CheckAuth><RenderHeader /></CheckAuth>} />
        </Routes>
        <Content>
          <Section>
            <Routes>
              <Route path={Config.routes.init} exact element={<CheckAuth><StartPage /></CheckAuth>} />
              <Route path={Config.routes.entry} exact element={<CheckAuth><RenderDetails /></CheckAuth>} />
            </Routes>
          </Section>
          <Sidebar>
            <Routes>
              <Route path={Config.routes.init} exact element={<CheckAuth><LatestNews /></CheckAuth>} />
              <Route path={Config.routes.entry} exact element={<CheckAuth><LatestNews withPadding /></CheckAuth>} />
            </Routes>
          </Sidebar>
        </Content>
      </Wrapper>
    </Container>
  );
};

export default News;
